import { SucursalState } from './state';

export const initialState: SucursalState = {
  sucursal: undefined,
};
